export default "/images/vendor/@coreui/icons/svg/flag/cif-ba.svg?71d72eea9cb504c4173292aa3e003694";